module.exports = "/images/Icon-1.svg?19b9be9874f37b47bd9320eef2904d8a";